import React, { useContext } from "react";
import LanguageContext from "../LanguageContext";
import { translations } from "../ModalForms/translations";

export const WHAT_WANT_LEARN = () => {
  const { language } = useContext(LanguageContext);

  return translations[language].privateClassesLernTopics;
};
